import { vaccinationsService } from "@/services/vaccinations.service";
import { SuggestedVaccination } from "@/types/vaccination";
import { useCallback, useState } from "react";

export const useVaccinationSuggestions = (memberId: string) => {
  const [suggestedVaccinations, setSuggestedVaccinations] = useState<SuggestedVaccination[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  const fetchSuggestions = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await vaccinationsService.getVaccinationPerAge(memberId);
      setSuggestedVaccinations(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(err instanceof Error ? err.message : 'Failed to fetch suggestions');
    }
  }, [memberId]);
  
  return {
    suggestedVaccinations,
    loading,
    error,
    fetchSuggestions,
  };
}